<template>
    <div class="loading-spinner">
        <div class="spinner-box">
            <div class="spinner"></div>
        </div>
        <h6 v-if="message" class="message">{{ message }}</h6>
    </div>
</template>

<script>
export default {
    name: "LoadingSpinner",
    props: {
        message: {
            type: String,
            default: "Please wait"
        }
    }
};
</script>

<style lang="scss" scoped>
.loading-spinner {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    .spinner-box {
        width: 50px;
        height: 50px;
        display: flex;
        align-items: center;
        justify-content: center;

        .spinner {
            width: 40px;
            height: 40px;
            border: 4px solid var(--color00);
            border-top: 4px solid var(--color07);
            border-radius: 50%;
            animation: spin 1s linear infinite;
        }
    }

    .message {
        margin-top: 14px;
        color: var(--dark01);
    }
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}
</style>
